import { FC } from "react";
import { Form, Grid } from "antd";
import { useTranslation } from "react-i18next";
import { withConditionalComponent } from "src/HOC";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { NationalityIcon } from "src/assets/Icons";
import { useNotify } from "src/context";
import i18n from "src/i18n";
import NationalitySelectWeb from "./layouts/NationalitySelect.web";
import NationalitySelectMob from "./layouts/NationalitySelect.mob";

const NationalitySelectComponent = withConditionalComponent(NationalitySelectWeb, NationalitySelectMob);

const NationalitySelect: FC<{ errorFields: string[] }> = ({ errorFields }) => {
  const { t } = useTranslation();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const name = "guestNationality";
  const hasError = errorFields.includes(name);
  const form = Form.useFormInstance();
  const location = Form.useWatch("location", form);
  const isUae = location?.country === "AE";
  const notify = useNotify();

  const fieldProps = {
    name,
    icon: NationalityIcon,
    label: t("Flights.details.form.nationality"),
    hasError,
    rules: [{ required: true, message: i18n.t("Flights.details.form.nationalityRequired") }],
    onOpen: () =>
      isUae &&
      notify.open({
        message: <div className="whitespace-break-spaces w-full!">{t("Hotels.search.uaeNationalityDescription")}</div>,
        placement: isLargeScreen ? "bottomRight" : "topRight",
        pauseOnHover: true,
        type: "warning",
      }),
  };

  return <NationalitySelectComponent trigger={isLargeScreen} props={fieldProps} />;
};

export default NationalitySelect;
